/**
 * Общая проверка для всех визуальных эффектов лендинга (снег, параллакс, наклон,
 * конфетти, свечение курсора): отключаются при `prefers-reduced-motion: reduce`
 * и там, где макет их отключал на тач-устройствах (`pointer: fine` — есть мышь).
 */
export function prefersReducedMotion(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function hasFinePointer(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(pointer: fine)').matches;
}
